jQuery(document).ready(($) => {
    if ( $(window).width() > 860 ) {
        $('.change-font-container').css('display','none')
    } else {
        $('.font-size-1').css('color','#108dde')

        // On click button Size1
        $('.font-size-1').click(function() {
            document.querySelectorAll('.change-font-container button').forEach((btn)=>{
                btn.style.color = 'black'
            })
            $('.font-size-1').css('color','#108dde')

            // Title
            document.querySelector('.entry-title').style.fontSize = '32px'
            document.querySelector('.entry-title').style.lineHeight = '32px'
            // SubTitle
            document.querySelector('.post-excerpt').style.fontSize = '20px'
            document.querySelector('.post-excerpt').style.lineHeight = '25px'
            // Content
            document.querySelector("div.entry-content").style.fontSize = '18px'
            document.querySelector("div.entry-content").style.lineHeight = '25px'
            document.querySelectorAll("div.entry-content p").forEach((p)=>{
                p.style.fontSize = '16px'
                p.style.lineHeight = '1.31'
            })

        });

        // Onclick button Size2
        $('.font-size-2').click(function() {
            document.querySelectorAll('.change-font-container button').forEach((btn)=>{
                btn.style.color = 'black'
            })
            $('.font-size-2').css('color','#108dde')

            // Title
            document.querySelector('.entry-title').style.fontSize = '36px'
            document.querySelector('.entry-title').style.lineHeight = '36px'
            // SubTitle
            document.querySelector('.post-excerpt').style.fontSize = '24px'
            document.querySelector('.post-excerpt').style.lineHeight = '29px'
            // Content
            document.querySelector("div.entry-content").style.fontSize = '22px'
            document.querySelector("div.entry-content").style.lineHeight = '29px'
            document.querySelectorAll("div.entry-content p").forEach((p)=>{
                p.style.fontSize = '20px'
                p.style.lineHeight = '1.35'
            })
        });

        // Onclick button Size3
        $('.font-size-3').click(function() {
            document.querySelectorAll('.change-font-container button').forEach((btn)=>{
                btn.style.color = 'black'
            })
            $('.font-size-3').css('color','#108dde')

            // Title
            document.querySelector('.entry-title').style.fontSize = '40px'
            document.querySelector('.entry-title').style.lineHeight = '40px'
            // SubTitle
            document.querySelector('.post-excerpt').style.fontSize = '28px'
            document.querySelector('.post-excerpt').style.lineHeight = '33px'
            // Content
            document.querySelector("div.entry-content").style.fontSize = '26px'
            document.querySelector("div.entry-content").style.lineHeight = '33px'
            document.querySelectorAll("div.entry-content p").forEach((p)=>{
                p.style.fontSize = '24px'
                p.style.lineHeight = '1.39'
            })
        });


        // Onclick button Size4
        $('.font-size-4').click(function() {
            document.querySelectorAll('.change-font-container button').forEach((btn)=>{
                btn.style.color = 'black'
            })
            $('.font-size-4').css('color','#108dde')

            // Title
            document.querySelector('.entry-title').style.fontSize = '44px'
            document.querySelector('.entry-title').style.lineHeight = '44px'
            // SubTitle
            document.querySelector('.post-excerpt').style.fontSize = '32px'
            document.querySelector('.post-excerpt').style.lineHeight = '37px'
            // Content
            document.querySelector("div.entry-content").style.fontSize = '30px'
            document.querySelector("div.entry-content").style.lineHeight = '37px'
            document.querySelectorAll("div.entry-content p").forEach((p)=>{
                p.style.fontSize = '28px'
                p.style.lineHeight = '1.42'
            })
        });

    }

});